import styled from '@emotion/styled'
import { WebLink, WebLinkProps, createPropFilter } from '@news-mono/web-common'
import { breakpoint, calcRem, metrics } from '../../../__styling'
import { tokens } from '@news-mono/design-tokens'

interface Layout {
    className?: string
}

export const StyledInlineContentCardsContainer = styled('div', {
    shouldForwardProp: createPropFilter<Layout>()(['layout', 'className']),
})<Layout>(({ theme }) => [
    {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridGap: `${calcRem(
            metrics.sevennews.margins.sm,
            metrics.sevennews.margins.gridGap,
        )}`,

        [breakpoint('xxs')]: {
            gridTemplateColumns: '1fr 1fr',
        },
    },
])

export const StyledLinkWrapper = styled(WebLink, {
    shouldForwardProp: createPropFilter<WebLinkProps>()(['layout', 'topic']),
})(({ theme }) => [
    {
        textDecoration: 'none',
        ['&:hover']: {
            textDecoration: 'underline',
            textDecorationColor: tokens.sevennews.colors.palette.black,
        },
    },
])
